import { render } from "./leadDetailVisualizza.vue?vue&type=template&id=db76d8ba&ts=true"
import script from "./leadDetailVisualizza.vue?vue&type=script&lang=ts"
export * from "./leadDetailVisualizza.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__